import { Box, Stack } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { CustomFieldSection, homePage } from 'api/home-page';
import styles from './styles';
import IconMi from 'components/common/icon/IconMi';
import React from 'react';
import { ITileInfoCustomFields } from '../types';

export default function InfoCustomFields({
    tile,
    customFieldsDisplayOnTileInfo,
    preloadedData,
}: {
    tile: ITileInfoCustomFields;
    customFieldsDisplayOnTileInfo: { [key: string]: string };
    preloadedData?: CustomFieldSection[];
}) {
    const showCustomFields =
        customFieldsDisplayOnTileInfo &&
        (('metric' === tile.element_type && 'Y' === customFieldsDisplayOnTileInfo['used_for_metric_ind']) ||
            ('multi-metric chart' === tile.element_type &&
                'Y' === customFieldsDisplayOnTileInfo['used_for_multimetric_ind']) ||
            ('internal report' === tile.element_type && 'Y' === customFieldsDisplayOnTileInfo['used_for_report_ind']) ||
            ('external report' === tile.element_type &&
                'Y' === customFieldsDisplayOnTileInfo['used_for_external_report_ind']) ||
            ('other external content' === tile.element_type &&
                'Y' === customFieldsDisplayOnTileInfo['used_for_external_content_ind']));

    const { data: loadedData } = useQuery<CustomFieldSection[], Error>({
        queryKey: [`tile-${tile.element_id}-custom-fields`],
        queryFn: () => {
            if (!preloadedData && showCustomFields) {
                return homePage.loadCustomFields(tile.element_id ?? 0, tile.element_type ?? '');
            }

            return [];
        },
    });

    const data = preloadedData ? preloadedData : loadedData;

    return showCustomFields && data && data.length > 0 ? (
        <Stack direction={'row'} sx={styles.sectionWrapper}>
            <Box sx={styles.iconHolder}>
                <IconMi icon="custom-field" sx={{ fontSize: '16px' }} />
            </Box>
            <Stack flexGrow={1} spacing={0.5} sx={{ overflow: 'hidden' }}>
                {data.map((section) => {
                    return (
                        <Box key={`custom-field-section-${section.label}`}>
                            <Box sx={{ fontWeight: 'bold', overflow: 'hidden', wordWrap: 'break-word' }}>
                                {section.label}
                            </Box>
                            <Stack spacing={0.25}>
                                {section.fields.map((field) => (
                                    <Stack
                                        direction={'row'}
                                        sx={styles.fixedValueRow}
                                        key={`custom-field-${field.name}`}
                                    >
                                        <Box className={'fixed-label'}>{`${field.name}:`}</Box>
                                        <Box
                                            className={'fixed-value markdown-holder'}
                                            dangerouslySetInnerHTML={{
                                                __html: field.values.join(', '),
                                            }}
                                        />
                                    </Stack>
                                ))}
                            </Stack>
                        </Box>
                    );
                })}
            </Stack>
        </Stack>
    ) : null;
}
